import { render, staticRenderFns } from "./Neu.vue?vue&type=template&id=2e27ffc6&"
import script from "./Neu.vue?vue&type=script&lang=js&"
export * from "./Neu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports